import { Component } from '@angular/core';

@Component({
  selector: 'app-terminal-layout',
  templateUrl: './terminal-layout.component.html',
  standalone: false,
})
export class TerminalLayoutComponent {}
